import { Send } from "@mui/icons-material";
import styled from "styled-components/macro";

/* istanbul ignore next */
export const StyledSendIcon = styled(Send)`
  transform: rotate(315deg);
  padding-bottom: 2px;
  padding-left: 5px;
`;
